import { Radio, SxProps, Theme } from '@mui/material'

import { switcherLabelWithImageStyle } from 'common/styles'
import FormControlLabel from 'components/FormControlLabel'
import ImageCard from 'components/ImageCard'

import { RadioImageOption } from '../interface'

interface RadioItemWithImageProps {
  option: RadioImageOption
}

const radioStyles: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
}

export default function RadioItemWithImage({ option }: RadioItemWithImageProps): JSX.Element {
  const { image, imageAltText, heading, subheading, value } = option

  return (
    <FormControlLabel
      sx={switcherLabelWithImageStyle}
      key={value}
      value={value}
      label={
        <ImageCard
          heading={heading}
          headingLevel={3}
          image={image}
          subheading={subheading}
          imageAltText={imageAltText}
        />
      }
      control={<Radio sx={radioStyles} />}
    />
  )
}
